<template>
  <div class="gallery-card31-gallery-card" v-bind:class="rootClassName">
    <img :alt="imageAlt" :src="imageSrc" class="gallery-card31-image" />
    <div class="gallery-card31-container">
      <h1 class="gallery-card31-text1">{{ title }}</h1>
      <!-- <span class="gallery-card31-text2">{{ subtitle }}</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "GalleryCard31",
  props: {
    imageSrc: {
      type: String,
      default:
        "https://images.unsplash.com/photo-1523755231516-e43fd2e8dca5?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDF8fG1pbmltYWxpc20lMjBjb3VjaHxlbnwwfHx8fDE2MjY0NDg1NTk&ixlib=rb-1.2.1&h=1000",
    },
    subtitle: {
      type: String,
      default: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    title: {
      type: String,
      default: "Project Title",
    },
    imageAlt: {
      type: String,
      default: "image",
    },
    rootClassName: String,
  },
};
</script>

<style scoped>
.gallery-card31-gallery-card {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.gallery-card31-image {
  top: 0px;
  left: 0px;
  right: auto;
  width: 100%;
  bottom: auto;
  height: 100%;
  position: absolute;
  object-fit: fill;
}
.gallery-card31-container {
  width: 100%;
  height: 300px;
  display: flex;
  opacity: 0;
  padding: 32px;
  z-index: 1;
  transition: 0.3s;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.9)
  );
}
.gallery-card31-container:hover {
  opacity: 1;
}
.gallery-card31-text1 {
  color: var(--dl-color-gray-white);
  font-size: 1.5rem;
  text-align: center;
  font-weight: 500;
  margin-bottom: 24px;
}
.gallery-card31-text2 {
  color: var(--dl-color-gray-white);
  text-align: center;
}

@media (max-width: 479px) {
  .gallery-card31-text1 {
    align-self: center;
    margin-bottom: var(--dl-space-space-unit);
  }
}
</style>
